import { render, staticRenderFns } from "./FichaTaxonomia.vue?vue&type=template&id=7548acd6&"
import script from "./FichaTaxonomia.vue?vue&type=script&lang=js&"
export * from "./FichaTaxonomia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports